<template>
  <div class="pou-block">
    <v-tabs v-model="tab">
      <v-tab key="variables">Variables</v-tab>
      <v-tab key="body">Body</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="full-height-tab">
      <v-tab-item>
        <variables :pouTempId="id" />
      </v-tab-item>
      <v-tab-item v-if="tab === 1">
        <div class="editor mt-5">
          <ILST
            v-if="['IL', 'ST'].includes(this.pou.body.language)"
            :pouTempId="id"
          />

          <div v-if="pou.body.language === 'FBD'" class="editor__main">
            <tool-bar class="editor__toolbar"></tool-bar>
            <fbd class="editor__main__draw" :pouTempId="id"></fbd>
          </div>

          <div v-if="pou.body.language === 'LD'" class="editor__main">
            <tool-bar class="editor__toolbar"></tool-bar>
            <ld class="editor__main__draw" :pouTempId="id"></ld>
          </div>

          <div v-if="pou.body.language === 'SFC'" class="editor__main">
            <tool-bar class="editor__toolbar"></tool-bar>
            <sfc class="editor__main__draw" :pouTempId="id"></sfc>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { find } from "lodash";
import Variables from "./Variables";
import Fbd from "./Fbd";
import Ld from "./Ld";
import Sfc from "./Sfc";
import ToolBar from "./ToolBar";
import ILST from "./ILST";

export default {
  name: "PouWindow",
  components: { Variables, Fbd, Ld, Sfc, ToolBar, ILST },
  props: ["id"],
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    pou() {
      return find(this.$store.state.pous, { tempId: this.id });
    },
  },
};
</script>

<style scoped lang="scss">
.pou-block {
  flex-grow: 2;

  // display: flex;
  // flex-direction: column;
}

.editor {
  height: calc(100vh - 290px);

  display: flex;
  flex-direction: row;

  &__main {
    flex: 1;

    display: flex;
    flex-direction: column;

    &__draw {
      flex: 1;

      display: flex;
      flex-direction: row;
    }
  }

  &__sidebar {
    flex: 0 0 80px;
    padding-top: 0px;
  }
}

.v-tabs-items.full-height-tab .v-window-item {
  height: calc(100vh - 270px); /* Adjust 270px to suits your needs */
  overflow-y: auto;
}
</style>

<style lang="scss">
.v-textarea.editor__main > * .v-input__slot {
  height: 100% !important;
}
</style>
